import { render, staticRenderFns } from "./DataTableConfig.vue?vue&type=template&id=7edb43c8&"
import script from "./DataTableConfig.vue?vue&type=script&lang=js&"
export * from "./DataTableConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports